import { render, staticRenderFns } from "./VenueSyncForm.vue?vue&type=template&id=a59fe410"
import script from "./VenueSyncForm.vue?vue&type=script&lang=ts"
export * from "./VenueSyncForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports